(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("McAiChatWidget", [], factory);
	else if(typeof exports === 'object')
		exports["McAiChatWidget"] = factory();
	else
		root["McAiChatWidget"] = factory();
})(self, () => {
return 